import React, {useState} from "react";
import {Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {Delete} from "@material-ui/icons";
import Popup from "../../../UI/Popup/Popup";

let Element = props => {
    // Handle Popup
    let [popupLauncher, setPopupLauncher] = useState (null);
    let [openPopup, setOpenPopup] = useState (false);
    let hidePopup = () => {
        setPopupLauncher (null);
        setOpenPopup (false);
    }
    let launchPopup = (e) => {
        setPopupLauncher (e.currentTarget);
        setOpenPopup (true);
    }
    let iconStyle = {
        color: '#c70000',
        width: '2rem',
        height: '2rem',
        transform: 'scale(0.8)',
        float: props.right ? 'none' : 'right',
        right: props.right ? '1rem' : 'auto',
        position: props.right ? 'absolute' : 'relative',
    }

    return <div>
        <Tooltip title={ `Delete ${ props.element }` }>
            <IconButton
                onClick={ (e) => {
                    e.stopPropagation ()
                    launchPopup (e)
                } }
                onFocus={ (e) => e.stopPropagation () }
                style={ iconStyle }
                aria-label={ `Delete ${ props.element.toLowerCase () }` }
                size={ "small" }>
                <Delete/>
            </IconButton>
        </Tooltip>

        <Popup
            anchorEl={ popupLauncher }
            show={ openPopup }
            onClose={ (e) => {
                e.stopPropagation ()
                hidePopup ()
            } }
            onSubmit={ (e, c) => {
                e.stopPropagation ()
                props.delete (c)
                hidePopup ()
            } }
            title={ `Delete ${ props.element } ?` }
            subtitle={ props.elementName }
            body={ props.alert }
            lang={ props.lang }
        />
    </div>
}

export default Element;